<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" placeholder="选择考试" @change="getPage({pageNum: 1})" filterable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="id" label="序号">
          <template slot-scope="scope">
            {{1+page.pageSize*(page.pageNum-1)+scope.$index}}
          </template>
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业"></el-table-column>
        <el-table-column prop="notRecordNum" label="未参加人数"></el-table-column>
        <el-table-column prop="notCompleteNum" label="未完成人数"></el-table-column>
        <el-table-column prop="completeNum" label="已完成人数"></el-table-column>
        <el-table-column prop="masterVideoNum" label="主机视频总数"></el-table-column>
        <el-table-column prop="monitorVideoNum" label="辅机视频总数"></el-table-column>
        <el-table-column prop="evaluateNum" label="已评分人数"></el-table-column>
        <el-table-column prop="notEvaluateNum" label="未评分人数"></el-table-column>
      </el-table>
      <div v-if="false" style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'exam-number-manage',
  components: {},
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, row: null, title: '考试人数' },
      batchList: []
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiMusicbasis.getBatchList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('请先添加考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let list = await this.$HTTP.ApiMusicbasis.getNumberInfo(this.queryParam.batchId)
        this.page = { list: list || [], pageNum: 1, pageSize: 10000, total: 10000, totalPage: 1 }
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
